"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.close = exports.open = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
const browser_utils_1 = require("@walletconnect/browser-utils");
const style_1 = require("./assets/style");
const Modal_1 = __importDefault(require("./components/Modal"));
const constants_1 = require("./constants");
const en = {
    choose_preferred_wallet: 'Choose your preferred wallet',
    connect_mobile_wallet: 'Connect to Mobile Wallet',
    scan_qrcode_with_wallet: 'Scan QR code with a Klip wallet',
    connect: 'Connect',
    qrcode: 'QR Code',
    mobile: 'Mobile',
    desktop: 'Desktop',
    copy_to_clipboard: 'Copy to clipboard',
    copied_to_clipboard: 'Copied to clipboard!',
    connect_with: 'Connect with',
    loading: 'Loading...',
    something_went_wrong: 'Something went wrong',
    no_supported_wallets: 'There are no supported wallets yet',
    no_wallets_found: 'No wallets found',
};
function injectStyleSheet() {
    const doc = (0, browser_utils_1.getDocumentOrThrow)();
    const prev = doc.getElementById(constants_1.KLIP_STYLE_ID);
    if (prev) {
        doc.head.removeChild(prev);
    }
    const style = doc.createElement('style');
    style.setAttribute('id', constants_1.KLIP_STYLE_ID);
    style.innerText = style_1.KLIP_STYLE_SHEET;
    doc.head.appendChild(style);
}
function renderWrapper() {
    const doc = (0, browser_utils_1.getDocumentOrThrow)();
    const wrapper = doc.createElement('div');
    wrapper.setAttribute('id', constants_1.KLIP_WRAPPER_ID);
    doc.body.appendChild(wrapper);
    return wrapper;
}
function triggerCloseAnimation() {
    const doc = (0, browser_utils_1.getDocumentOrThrow)();
    const modal = doc.getElementById(constants_1.KLIP_MODAL_ID);
    if (modal) {
        modal.className = modal.className.replace('fadeIn', 'fadeOut');
        setTimeout(() => {
            const wrapper = doc.getElementById(constants_1.KLIP_WRAPPER_ID);
            if (wrapper) {
                doc.body.removeChild(wrapper);
            }
        }, constants_1.ANIMATION_DURATION);
    }
}
function getWrappedCallback(cb) {
    return () => {
        triggerCloseAnimation();
        if (cb) {
            cb();
        }
    };
}
function open(uri, cb, qrcodeModalOptions) {
    injectStyleSheet();
    const wrapper = renderWrapper();
    ReactDOM.render((0, jsx_runtime_1.jsx)(Modal_1.default, { text: en, uri: uri, onClose: getWrappedCallback(cb), qrcodeModalOptions: qrcodeModalOptions }), wrapper);
}
exports.open = open;
function close() {
    triggerCloseAnimation();
}
exports.close = close;
